/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CommunicationStatusEnum = {
    Sent: 'SENT',
    Rejected: 'REJECTED',
    PartlyRejected: 'PARTLY_REJECTED'
} as const;
export type CommunicationStatusEnum = typeof CommunicationStatusEnum[keyof typeof CommunicationStatusEnum];

